import { ProjectSetupPage } from './ProjectSetupPage';
import { withProjectSetupPage } from './withProjectSetupPage';

const ConnectedProjectSetupPage = withProjectSetupPage(ProjectSetupPage);

export { ConnectedProjectSetupPage as ProjectSetupPage };
